import React from "react";

import { I, T } from "services/lang/LanguageService";
import { Button } from "primereact/button";
import { StatusMonitoringIndicator, Visuals } from "../charts/interfaces";
import "./DatasetStatusMonitoring.css";

interface DatasetStatusIndicatorProps {
  currentIndicator: StatusMonitoringIndicator;
  scale: number;
  soundOn: boolean;
  isMuted: boolean;
  setSoundOn: (val: boolean) => void;
  setIsMuted: (val: boolean) => void;
  isSoundButtonEnabled: boolean;
}

const DatasetStatusIndicator = ({
  currentIndicator,
  scale,
  soundOn,
  isMuted,
  setSoundOn,
  setIsMuted,
  isSoundButtonEnabled,
}: DatasetStatusIndicatorProps) => {
  const iconClassName = currentIndicator.visual === Visuals.BLINK ? "blinking-icon" : "";
  const itemsScale = scale || 1;

  const titleStyle = {
    fontSize: `${itemsScale * 1}rem`,
  };

  const iconStyle = {
    color: currentIndicator.color,
    fontSize: `${itemsScale * 1.5}rem`,
    padding: `${itemsScale * 2}px`,
    margin: "auto",
    lineHeight: 1.5,
  };

  return (
    <div className="flex flex-row justify-content-between align-items-center">
      <div className="flex flex-row gap-3 align-items-center">
        <i className={`${currentIndicator.icon} ${iconClassName}`} style={iconStyle} />
        <div style={titleStyle}>{I(currentIndicator.title)}</div>
      </div>
      {currentIndicator.sound && (
        <Button
          icon={currentIndicator.sound && soundOn ? "pi pi-volume-off" : "pi pi-volume-up"}
          label={currentIndicator.sound && soundOn ? T("action.mute") : T("action.sound-on")}
          onClick={() => {
            setSoundOn(!soundOn);
            setIsMuted(!isMuted);
          }}
          disabled={!currentIndicator.sound || !isSoundButtonEnabled}
          className="component-editor-button icon-blue text-lg"
        />
      )}
    </div>
  );
};

export default DatasetStatusIndicator;
